const createToast = () => {
  return new Notyf({
    duration: 4000,
    position: {
      x: 'right',
      y: 'top',
    },
    dismissible: true,
    ripple: false,
    types: [
      {
        type: 'success',
        background: 'var(--black-500)'
      },
      {
        type: 'error',
        background: '#E53E3E'
      }
    ]
  });
};

window.notyf = createToast();
